import React from 'react'
import { Tooltip } from '@mui/material'
import Button from '@material-ui/core/Button'

const FeedbackTooltip = ({ record }) => {
  return (
    <Tooltip title={record.comment} disableInteractive>
      <Button color="primary">{record.outcome}</Button>
    </Tooltip>
  )
}

export default FeedbackTooltip
